export default {
  storeCategories: {
    error: null,
    loading: false,
    success: false,
    categoryList: [],
  },
  addUpdateStore: {
    error: null,
    loading: false,
    success: false,
    message: '',
  },
  comments: {
    data: null,
    loading: false,
    error: null,
  },
  postComment: {
    error: null,
    loading: false,
    success: false,
    message: '',
  },
  addStoreAgents: {
    data: null,
    loading: false,
    error: null,
    success: false,
  },
  deleteStoreAgents: {
    data: null,
    loading: false,
    error: null,
    success: false,
  },
  listStoreAgents: {
    data: null,
    loading: false,
    error: null,
    success: false,
  },
  getMerchantTypeList: {
    data: null,
    loading: false,
    error: null,
    success: false,
  }
  
};
